module.exports = __webpack_public_path__ + "img/cach-icon.c7e995fc.svg";